export default __webpack_public_path__ + "static/media/flag-sq.9536cc47.svg";